export default "assets/images/icons/star-feafb685.svg";